export default {
  // 企業情報
  PAGE_TITLE: "公司信息",
  COMPANY_INFO: "公司信息",
};
